<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.closedLoop.step1.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.type"
          :label="$t('technicalFile.closedLoop.step1.filtration')"
          :items="displayedUnits('closedLoopFiltration')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="yesOrno"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <div v-if="!(data.type === 'no' || data.type === null)">
      <v-row class="xPadding">
        <v-col class="py-0">
          <VTextField
            v-model="data.capacity.value"
            :label="$t('technicalFile.closedLoop.step1.capacity')"
            :formatNumber="true"
            type="number"
            min="0"
            class="text-field-transparent"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col class="py-0">
          <VSelect
            v-model="data.capacity.units"
            :label="$t('technicalFile.closedLoop.step1.unit')"
            :items="displayedUnits('loopCapacity')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col class="py-0">
          <VSelect
            v-model="data.capacity.time"
            :label="$t('technicalFile.closedLoop.step1.per')"
            :items="displayedUnits('timeUnits')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col class="py-0">
          <VTextField
            v-model="data.filtrationLevel.value"
            :label="$t('technicalFile.closedLoop.step1.level')"
            :formatNumber="true"
            type="number"
            min="0"
            class="text-field-transparent"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col class="py-0">
          <VSelect
            v-model="data.filtrationLevel.units"
            :label="$t('technicalFile.closedLoop.step1.unit')"
            :items="displayedUnits('filtrationLevel')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col class="py-0">
          <VSelect
            v-model="data.openBassing"
            :label="$t('technicalFile.closedLoop.step1.openBassin')"
            :items="displayedUnits('yesOrNone')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col class="py-0">
          <VSelect
            v-model="data.expansionTank"
            :label="$t('technicalFile.closedLoop.step1.expansionTank')"
            :items="displayedUnits('yesOrNone')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Filtration',
    components: {
        VTextField,
    },
    props: {
        filtration: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                capacity: {},
                filtrationLevel: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
        displayedTypes() {
            return ['no', 'multimedia', 'bag', 'cartridge', 'other'].map(type => ({
                name: this.$t(`technicalFile.closedLoop.step1.${type}`),
                key: type,
            }));
        },
    },
    watch: {
        filtration: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.filtration) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { filtration: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
